import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import dayjs from "dayjs";

import {
  Grid,
  Stack,
  Chip,
  Box,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import DetailHeader from "../components/detail/detailHeader";
import {
  DivCoverReturn,
  DivContent,
  DivTopic,
  TextMainTopic,
  TextData,
  ViewButton,
  TextTopic,
  DivTopicAndData,
  LinkStyled,
  StatusData,
} from "../../../shared/styledComponent";

import DeleteModal from "../../../shared/deleteModal";
import GoogleApi from "../../../user/sampleshuttle/NewSample/CardDetailSample/showMap";
import { postDeleteDeliverySampleshuttle } from "../../../../../actions/deliverySampleshuttle";
import { getDeliverySampleshuttleByAdminFilter } from "../../../../../actions/deliverySampleshuttle";
import LocationOnIcon from "@mui/icons-material/LocationOn";

require("dayjs/locale/th");
dayjs.locale("th");

const DetailDeliverySampleShuttle = (props) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [openModal, setOpenModal] = useState(false);
  const [booking, setBooking] = useState(props.location.state.booking);

  const checkIsPicture = (index) => {
    const paths = JSON.parse(booking.path);
    const tailName = paths[index].fileName.split(".")[1];
    if (tailName === "jpg" || tailName === "png" || tailName === "jpeg") {
      return true;
    }
    return false;
  };

  const takeAtl = (index) => {
    const paths = JSON.parse(booking.path);
    return paths[index].fileName;
  };

  useEffect(() => {
    console.log("DetailBooking props:", props.location.state);
    console.log("State Booking: ", props.location.state.booking);

    if (props.location.state === undefined) {
      props.history.push("/admin/car_management");
    } 
    // else {
    //   setBooking(props.location.state?.booking);
    // }
  }, [props.location.state.booking]);

  const onCloseModalHandle = () => {
    setOpenModal(false);
  };

  const onClickOpenModal = () => {
    setOpenModal(true);
  };

  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.up("sm"));

  const [openDeleteBooking, setOpenDeleteBooking] = useState(false);

  const onDeleteHandler = () => {
    setOpenDeleteBooking(true);
  };
  const onCloseDialog = () => {
    setOpenDeleteBooking(false);
  };
  const onClickDeleteList = async () => {
    const id = booking.idDeliverySampleShuttle;
    const myData = {
      id: id,
    };
    console.log("deleting : " + myData.id);
    const data = await dispatch(postDeleteDeliverySampleshuttle(myData))
      .then((res) => {
        if (res.status === 200) {
          enqueueSnackbar("Delete Success", { variant: "success" });
          setOpenDeleteBooking(false);
          if (props.formData) {
            dispatch(getDeliverySampleshuttleByAdminFilter(props.formData));
          }
          props.history.goBack();
        } else {
          enqueueSnackbar("Delete Failed", { variant: "error" });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      {booking && (
        <DivCoverReturn>
          <DivContent>
            <DetailHeader
              title="จองรถรับส่งตัวอย่าง"
              onBack={() => props.history.goBack()}
              onEdit={() =>
                props.history.push(
                  "/admin/car_management/delivery_sample_shuttle/edit_detail",
                  { booking: booking }
                )
              }
              onDelete={onDeleteHandler}
            />

            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <TextMainTopic>งานที่ {booking.no}</TextMainTopic>
            </div>

            <DivTopic>
              <TextMainTopic>รายละเอียดตัวอย่าง</TextMainTopic>
              <Grid item sm={12}>
                <DivTopicAndData>
                  <TextTopic>ชื่อตัวอย่าง</TextTopic>
                  <TextData>{booking.nameSample}</TextData>
                </DivTopicAndData>
              </Grid>
              <Grid item sm={12}>
                <DivTopicAndData>
                  <TextTopic>Grade</TextTopic>
                  <TextData>{booking.nameGrade}</TextData>
                </DivTopicAndData>
              </Grid>
              <Grid item sm={12}>
                <DivTopicAndData>
                  <TextTopic>Lot Number</TextTopic>
                  <TextData>{booking.lotNumber}</TextData>
                </DivTopicAndData>
              </Grid>
              <Grid item sm={12}>
                <DivTopicAndData>
                  <TextTopic>รายละเอียดเพิ่มเติม</TextTopic>
                  <TextData>{booking.detail ? booking.detail : "-"}</TextData>
                </DivTopicAndData>
              </Grid>
              <Grid item sm={12}>
                <DivTopicAndData>
                  <TextTopic>ไฟล์เพิ่มเติม</TextTopic>
                </DivTopicAndData>
              </Grid>
              {booking.urlFiles != undefined && (
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <DivTopicAndData style={{ width: "100%" }}>
                    <Stack
                      direction="column"
                      spacing={1}
                      sx={{
                        width: "100%",
                      }}
                    >
                      {booking.urlFiles != null && (
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            flexWrap: "wrap",
                          }}
                        >
                          <Stack
                            direction="row"
                            sx={{
                              width: "100%",
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "10px",
                            }}
                          >
                            {booking.urlFiles.map((value, index) => (
                              <>
                                {checkIsPicture(index) === true && (
                                  <LinkStyled
                                    href={value}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img
                                      src={`${value}`}
                                      alt={`${takeAtl(index)}`}
                                      style={{
                                        height: "100%",
                                        width: "100%",
                                      }}
                                    />
                                  </LinkStyled>
                                )}
                              </>
                            ))}
                          </Stack>
                          <Stack
                            direction="row"
                            sx={{
                              width: "100%",
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "10px",
                            }}
                          >
                            {booking.urlFiles.map((value, index) => (
                              <>
                                {checkIsPicture(index) === false && (
                                  <Box
                                    key={`file_${index}`}
                                    sx={{
                                      maxWidth: "calc(100%)",
                                      display: "flex",
                                    }}
                                  >
                                    <Chip
                                      key={`file_${index}`}
                                      label={`${takeAtl(index)}`}
                                      color="primary"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      component="a"
                                      href={value}
                                      clickable
                                      sx={{
                                        width: "100%",
                                      }}
                                    />
                                  </Box>
                                )}
                              </>
                            ))}
                          </Stack>
                        </div>
                      )}
                    </Stack>
                  </DivTopicAndData>
                </Grid>
              )}
            </DivTopic>

            <DivTopic>
              <TextMainTopic>จุดรับส่งของ</TextMainTopic>
              <Grid item sm={12}>
                <DivTopicAndData>
                  <LocationOnIcon
                    sx={{
                      height: "20px",
                      color: "green",
                      verticalAlign: "middle",
                      marginRight: "4px",
                    }}
                  />
                  <TextTopic>จุดรับของต้นทาง</TextTopic>
                  <TextData>
                    Site {booking.fromPlaceNoSite}: {booking.fromPlaceName}
                  </TextData>
                </DivTopicAndData>
              </Grid>
              <Grid item sm={12}>
                <DivTopicAndData>
                  <LocationOnIcon
                    sx={{
                      height: "20px",
                      color: "red",
                      verticalAlign: "middle",
                      marginRight: "4px",
                    }}
                  />
                  <TextTopic>จุดส่งของปลายทาง</TextTopic>
                  <TextData>
                    Site {booking.toPlaceNoSite}: {booking.toPlaceName}
                  </TextData>
                </DivTopicAndData>
              </Grid>
            </DivTopic>

            <DivTopic>
              <TextMainTopic>รายละเอียดผู้ส่ง</TextMainTopic>
              <Grid container spacing={2} flexWrap="wrap">
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <DivTopicAndData>
                    <TextTopic>ชื่อผู้ส่ง</TextTopic>
                    <TextData>{booking.nameSender}</TextData>
                  </DivTopicAndData>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <DivTopicAndData>
                    <TextTopic>เบอร์ผู้ส่ง</TextTopic>
                    <TextData>{booking.phoneSender}</TextData>
                  </DivTopicAndData>
                </Grid>
              </Grid>
              <Grid container spacing={2} flexWrap="wrap">
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <DivTopicAndData>
                    <TextTopic>วันที่ส่ง</TextTopic>
                    <TextData>
                      {booking.date &&
                        new Date(booking.date).toLocaleDateString("th-TH", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })}
                    </TextData>
                  </DivTopicAndData>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <DivTopicAndData>
                    <TextTopic>เวลาที่ส่ง</TextTopic>
                    <TextData>{booking.startTime}</TextData>
                  </DivTopicAndData>
                </Grid>
              </Grid>
            </DivTopic>

            <DivTopic>
              <TextMainTopic>รายละเอียดผู้รับ</TextMainTopic>
              <Grid container spacing={2} flexWrap="wrap">
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <DivTopicAndData>
                    <TextTopic>ชื่อผู้รับ</TextTopic>
                    <TextData>{booking.nameRecipient}</TextData>
                  </DivTopicAndData>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <DivTopicAndData>
                    <TextTopic>เบอร์ผู้รับ</TextTopic>
                    <TextData>{booking.phoneRecipient}</TextData>
                  </DivTopicAndData>
                </Grid>
              </Grid>
              {booking.deliveryStatus === "ได้รับสินค้าเรียบร้อย" && (
                <Grid container spacing={2} flexWrap="wrap">
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <DivTopicAndData>
                      <TextTopic>วันที่รับ</TextTopic>
                      <TextData>
                        {" "}
                        {booking.completedDate &&
                          new Date(booking.completedDate).toLocaleDateString(
                            "th-TH",
                            {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            }
                          )}
                      </TextData>
                    </DivTopicAndData>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <DivTopicAndData>
                      <TextTopic>เวลาที่รับ</TextTopic>
                      <TextData>
                        {booking.completedDate &&
                          new Date(booking.completedDate).toLocaleTimeString(
                            "th-TH",
                            {
                              hour: "2-digit",
                              minute: "2-digit",
                            }
                          )}
                      </TextData>
                    </DivTopicAndData>
                  </Grid>
                </Grid>
              )}
            </DivTopic>

            <DivTopic container>
              <TextMainTopic>รายละเอียดคนขับรถ</TextMainTopic>
              {booking.idDriver ? (
                <Grid container spacing={2} flexWrap="wrap">
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <DivTopicAndData>
                      <TextTopic>ชื่อคนขับ</TextTopic>
                      <TextData>{booking.driverFullName}</TextData>
                    </DivTopicAndData>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <DivTopicAndData>
                      <TextTopic>เบอร์คนขับ</TextTopic>
                      <TextData>{booking.driverTelephone}</TextData>
                    </DivTopicAndData>
                  </Grid>
                </Grid>
              ) : (
                <Grid container spacing={2} flexWrap="wrap">
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <DivTopicAndData>
                      <TextTopic>ชื่อคนขับ</TextTopic>
                      <StatusData style={{ color: "#d42121" }}>
                        กำลังหาคนขับรถ
                      </StatusData>
                    </DivTopicAndData>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <DivTopicAndData>
                      <TextTopic>เบอร์คนขับ</TextTopic>
                      <StatusData style={{ color: "#d42121" }}>
                        กำลังหาคนขับรถ
                      </StatusData>
                    </DivTopicAndData>
                  </Grid>
                </Grid>
              )}
            </DivTopic>

            <DivTopic>
              <TextMainTopic>สถานะการส่งตัวอย่าง</TextMainTopic>
              <Grid item sm={12}>
                <DivTopicAndData>
                  <TextTopic>สถานะ</TextTopic>
                  {booking.deliveryStatus === "ได้รับสินค้าเรียบร้อย" && (
                    <StatusData
                      style={{ color: "#24944f" }}
                    >{`${booking.deliveryStatus}`}</StatusData>
                  )}
                  {booking.deliveryStatus === "รอรับสินค้า" && (
                    <StatusData
                      style={{ color: "#d42121" }}
                    >{`${booking.deliveryStatus}`}</StatusData>
                  )}
                  {booking.deliveryStatus === "รับสินค้าเรียบร้อย" && (
                    <StatusData
                      style={{ color: "#FF9800" }}
                    >{`${booking.deliveryStatus}`}</StatusData>
                  )}
                  {booking.deliveryStatus === "ส่งสินค้าเรียบร้อย" && (
                    <StatusData
                      style={{ color: "#2196F3" }}
                    >{`${booking.deliveryStatus}`}</StatusData>
                  )}
                </DivTopicAndData>
              </Grid>
              {(booking.status === "ส่งสินค้าเรียบร้อย" ||
                booking.status === "ได้รับสินค้าเรียบร้อย") && (
                <Grid container spacing={2} flexWrap="wrap">
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <DivTopicAndData>
                      <TextTopic>วันที่ส่งของสำเร็จ</TextTopic>
                      <TextData>
                        {booking.sendDate &&
                          ` ${new Date(booking.sendDate).toLocaleDateString(
                            "th-TH",
                            {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            }
                          )}`}
                      </TextData>
                    </DivTopicAndData>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <DivTopicAndData>
                      <TextTopic>เวลาที่ส่งของสำเร็จ</TextTopic>
                      <TextData>
                        {booking.sendDate &&
                          `${new Date(booking.sendDate).toLocaleTimeString(
                            "th-TH",
                            {
                              hour: "2-digit",
                              minute: "2-digit",
                            }
                          )}`}
                      </TextData>
                    </DivTopicAndData>
                  </Grid>
                </Grid>
              )}
            </DivTopic>
            <Grid item xs={12}>
              <ViewButton onClick={onClickOpenModal}>แสดงแผนที่</ViewButton>
            </Grid>
          </DivContent>
          <GoogleApi
            open={openModal}
            onCloseHandle={onCloseModalHandle}
            inforInCar={booking}
            typeOfBooking={"DeliverySampleShuttle"}
          />
          <DeleteModal
            open={openDeleteBooking}
            onCloseDeleteModalHandle={onCloseDialog}
            onClickDelete={onClickDeleteList}
            label={"ลบรายการจอง"}
          />
        </DivCoverReturn>
      )}
    </>
  );
};

export default DetailDeliverySampleShuttle;
